import {
    IconButton,
    InputAdornment,
    TextField,
    TextFieldProps,
} from '@mui/material';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { colors } from 'common/constants';

type BaseNumberFieldProps = TextFieldProps & {
    name: string;
    min: number;
    max?: number;
    showMinus?: boolean;
    showPlus?: boolean;
    forceDisableMinus?: boolean;
    forceDisablePlus?: boolean;
};

const BaseNumberField: React.FC<BaseNumberFieldProps> = ({
    name,
    hiddenLabel = true,
    min = 1,
    max,
    InputProps,
    forceDisableMinus = false,
    forceDisablePlus = false,
    showMinus = true,
    showPlus = true,
    ...props
}) => {
    const { control } = useFormContext();
    return (
        <Controller
            control={control}
            name={name}
            render={({ field, fieldState }) => (
                <>
                    <TextField
                        {...field}
                        error={!!fieldState.error}
                        helperText={
                            fieldState.error ? fieldState.error.message : ''
                        }
                        hiddenLabel={hiddenLabel}
                        type="number"
                        FormHelperTextProps={{
                            sx: {
                                fontSize: '14px',
                                marginLeft: 0,
                                color: `${colors.textError} !important`,
                                fontWeight: '400',
                            },
                        }}
                        InputProps={{
                            ...InputProps,
                            inputProps: { min, max },
                            startAdornment: showMinus && (
                                <InputAdornment position="start">
                                    <IconButton
                                        aria-label="Decrease"
                                        disabled={
                                            forceDisableMinus ||
                                            field.value <= min
                                        }
                                        onClick={() => {
                                            field.onChange(
                                                Number(field.value) - 1
                                            );
                                        }}
                                    >
                                        <RemoveIcon />
                                    </IconButton>
                                </InputAdornment>
                            ),
                            endAdornment: showPlus && (
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="Increase"
                                        disabled={
                                            forceDisablePlus ||
                                            !!(max && field.value >= max)
                                        }
                                        onClick={() =>
                                            field.onChange(
                                                Number(field.value) + 1
                                            )
                                        }
                                    >
                                        <AddIcon />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                        {...props}
                    />
                </>
            )}
        />
    );
};

export default BaseNumberField;
